<template>
  <ProfileContainer />
</template>

<script lang="ts">
import Vue from "vue";
import ProfileContainer from "@/components/profile/container/ProfileContainer.vue";

export default Vue.extend({
  components: {
    ProfileContainer,
  },
});
</script>
